/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import EditIcon from "../assets/editIcon.svg";
import DisabledEditIcon from "../assets/disabledEditIcon.svg";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
import LaunchIcon from '@material-ui/icons/Launch';
import { AddProduct } from './patientChart/AddProduct/v1';
import { PatientChartControllerHOC } from '../controllers/patientChart';
import { getScrollbarWidth } from "../common/helper";
import ConsultTabStyles from "../styles/consultTabStyles";
import { removeXSSAttacks } from "../common/helper";
import ChangeProduct from "./subComponents/changeProduct";
import { ALTERNATE_RX_PRODUCT_VALUE } from '../constants/product.constant';
import { hasAlternateRx as hasAlternateRxInOrder } from '../utils/alternateRx';
import { FEATURE } from '../utils/feature';

const ControlledAddProduct = PatientChartControllerHOC(AddProduct);

const hasFeature = FEATURE();

class ConsultTab extends React.Component {
  state = {
    selectedProductId: void 0,
    QTYValue: void 0,
    orgQTYValue: void 0,
    reasonForChangeValue: "",
    currentProduct: void 0,
  };

  onSubmitProductChange = () => {
    let {
      SaveProductChanges,
      selectedPatientInfo: { UserId } = {},
      selectedCardData: { DoctorId = "" } = {},
      productInfo: { OrderId, StoreFrontData = {} } = {},
      qtyByProduct: { QTY = "", DefaultQty } = {},
      routePath,
    } = this.props;
    SaveProductChanges &&
      SaveProductChanges({
        UserId,
        OrderId,
        DoctorId,
        OldProductId: this.state.currentProduct,
        NewProductId: this.state.selectedProductId,
        Qty:
          this.state.QTYValue ||
          DefaultQty ||
          (!QTY.length ? this.state.orgQTYValue : QTY),
        ReasonForChange: this.state.reasonForChangeValue,
        routePath,
        storefrontCompanyId: StoreFrontData.CompanyId,
      });
    this.setState({
      currentProduct: void 0,
      selectedProductId: void 0,
      QTYValue: void 0,
      orgQTYValue: void 0,
      reasonForChangeValue: "",
    });
  };

  handleReasonForChange = (e) => {
    this.setState({ reasonForChangeValue: e.target.value });
  };
  handleProductListChange = (e) => {
    let { GetQtyByProduct, productInfo: { OrderId } = {} } = this.props;
    this.setState({
      selectedProductId: e.target.value,
      QTYValue: void 0,
      reasonForChangeValue: "",
    });
    GetQtyByProduct && GetQtyByProduct({ ProductId: e.target.value, OrderId });
  };

  handleQuantityChange = (e) => {
    this.setState({ QTYValue: e.target.value });
  };

  ToggleModal = (value, index) => {
    let { HandleGlobalValueChange = () => {}, reference } = this.props;
    
    const hasCommonModal = reference.commonModal.size > 0;
    if (hasCommonModal && value) {
      return;
    }

    if (typeof index === "number") {
      const {
        productInfo: { Product = [], OrderId } = {},
        GetProductList = () => {},
        GetQtyByProduct = () => {},
      } = this.props;
      GetProductList({ OrderId, ProductId: Product[index].ProductId });
      GetQtyByProduct({ OrderId, ProductId: Product[index].ProductId });
      this.setState({
        currentProduct: Product[index].ProductId,
        selectedProductId: Product[index].ProductId,
        QTYValue: Product[index].Qty,
        orgQTYValue: Product[index].Qty,
      });
    } else {
      this.setState({
        currentProduct: void 0,
        selectedProductId: void 0,
        QTYValue: void 0,
        orgQTYValue: void 0,
        reasonForChangeValue: "",
      });
    }
    HandleGlobalValueChange({
      value,
      type: 'commonModal',
      name: 'isProductChangeModalOpen',
    });
  };
  handleChange = (e, index) => {
    let {
      productInfo,
      emailTemplateValue = -1,
      productInfo: { Product = [] } = {},
      SetProductInfo = async () => {},
      ResetSubjectAndMailFromSalesforce = async () => {},
    } = this.props;
    Product = [...Product];
    if (Product[index].checked) {
      Product[index].checked = false;
    } else {
      Product[index].checked = true;
    }
    productInfo = { ...productInfo, Product };
    SetProductInfo(productInfo);

    if (emailTemplateValue !== -1 && !Product[index].checked) {
      ResetSubjectAndMailFromSalesforce({ pId: Product[index].ProductId });
    }
  };
  checkDisabled = (index) => {
    const { productInfo: { Product = [] } = {} } = this.props;
    const hasAlternateRx = hasAlternateRxInOrder({ products: Product });

    if (hasAlternateRx && Product[index].ProductId !== ALTERNATE_RX_PRODUCT_VALUE) {
      return true;
    }

    if (Product[index].checked) {
      for (let i = 0; i < Product.length; i++) {
        if (index !== i && Product[i].checked) {
          return false;
        }
      }
      return true;
    }

    return false;
  };

  handleOpenJumpstart = async () => {
    const { GetDoseSpot = () => {}, HandleGlobalValueChange = () => {}, productInfo } = this.props;
    const product = productInfo.Product[0];

    const response = await GetDoseSpot({ OrderId: productInfo.OrderId, ProductId: product.ProductId });
    if (response.status !== 200) {
      // show error message
      return false;
    }

    HandleGlobalValueChange({
      value: true,
      type: 'commonModal',
      name: 'approveAndSendEmailOpen',
    });
  }

  genrateData = (data = {}) => {
    let obj = {
      OrderDate: [],
      OrderId: [],
      ProductTitle: [],
      editIcon: [],
      Qty: [],
      OrderType: [],
      Status: [],
    };
    let { classes, notEditIcon, isEditDisabled } = this.props;
    if (data.OrderDate || data.OrderDate === 0) {
      obj.OrderDate.push(
        <div
          id="consult-order-date-row"
          title={data.OrderDate}
          className={`${classes.tableRow}`}
        >
          {data.OrderDate}
        </div>
      );
    } else {
      obj.OrderDate.push(null);
    }

    if (data.OrderId || data.OrderId === 0) {
      obj.OrderId.push(
        <div
          id="consult-order-id-row"
          title={data.OrderId}
          className={`${classes.tableRow} ${classes.tableRowBold}`}
        >
          {data.OrderId}
        </div>
      );
    } else {
      obj.OrderId.push(null);
    }
    let { Product = [] } = data;
    for (let i = 0; i < Product.length; i++) {
      const isCheckboxDisabled = this.checkDisabled(i);
      const isAlternateRx = Product[i].IsAlternateRx;
      const isLabProduct = !!Product[i].IsLabProduct;
      const orderType = isLabProduct ? 'Lab' : Product[i].OrderType;
      const quantity = Product[i].Qty;
      const status = isLabProduct ? Product[i].LabStatus : Product[i].Status;

      obj.ProductTitle.push(
        <div title={Product[i].displayTitle} className={`${classes.tableRow}`}>
          {Product.length > 1 && !notEditIcon ? (
            <Checkbox
              title=""
              id={`checkbox${i}`}
              disabled={isCheckboxDisabled}
              className={
                isCheckboxDisabled || !Product[i].checked
                  ? classes.disabledCheckbox
                  : classes.checkbox
              }
              checked={Product[i].checked}
              onChange={(e) => this.handleChange(e, i)}
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          ) : null}
          <div className={classes.tableRowEllipsis}>
            {Product[i].displayTitle}
          </div>

          {
            this.isConfiguredAlternateRx({
              pId: Product[i].ProductId,
              isAlternateRx: isAlternateRx,
              skipCheckingChangeProducts: true,
              skipCheckingAppSettings: false,
            }) && (
              <Tooltip title="DoseSpot Jumpstart" placement="top" arrow>
                <IconButton aria-label="dosespot-jumpstart" size="small" onClick={this.handleOpenJumpstart}>
                  <LaunchIcon fontSize="inherit" style={{ color: "#02ad50" }} />
                </IconButton>
              </Tooltip>
            )
          }
        </div>
      );
      !notEditIcon &&
        obj.editIcon.push(
          <div id="consult-edit-row" className={classes.imageWrapper}>
            <img
              alt=""
              key={`editIcon-${
                (isAlternateRx || isEditDisabled || isLabProduct) ? "enabled" : "disabled"
              }`}
              onClick={(_) =>
                !(isAlternateRx || isEditDisabled || isLabProduct) && this.ToggleModal(true, i)
              }
              id="changeProductIcon"
              title={"Edit Product"}
              className={`${classes.editIcon} ${
                (isAlternateRx || isEditDisabled || isLabProduct) ? classes.disabledEditIcon : ""
              }`}
              src={
                (isAlternateRx || isEditDisabled || isLabProduct) ? DisabledEditIcon : EditIcon
              }
            />
          </div>
        );
      obj.Qty.push(
        <div
          title={quantity}
          id="consult-qty-row"
          className={`${classes.tableRow} ${classes.tableCenter}`}
        >
          {quantity}
        </div>
      );
      obj.OrderType.push(
        <div
          title={orderType}
          id="consult-order-type-row"
          className={`${classes.tableRow} ${classes.tableCenter}`}
        >
          {orderType}
        </div>
      );
      obj.Status.push(
        <div
          title={status}
          id="consult-order-status-row"
          className={`${classes.tableRow} ${classes.tableCenter}`}
        >
          {status}
        </div>
      );
    }
    return obj;
  };

  componentDidMount() {
    window && window.addEventListener("resize", this.onResize);

    const { getPdf: { api: getPdfAPI } } = this.props;
    if (!getPdfAPI.called && !getPdfAPI.loading) {
      this.CheckIfPDFExists();
    }
  }
  UNSAFE_componentWillUnmount() {
    window && window.removeEventListener("resize", this.onResize);
  }

  componentDidUpdate() {
    const {
      getPdf,
      changeProducts = {},
      selectedCardData = {},
      productInfo = {},

      // actions
      GetChangeProductList: getChangeProducts = async () => {},
    } = this.props;

    if ((Number(selectedCardData.OrderId) !== getPdf.orderId) && getPdf.api.called && !getPdf.api.loading) {
      this.CheckIfPDFExists();
    }

    const hasOrderId = !!selectedCardData.OrderId;
    const hasProduct = !!(productInfo && productInfo.productIds && productInfo.productIds.length);
    const isCPNeverCalled = !changeProducts.api.called && !changeProducts.api.loading;

    if (hasOrderId && hasProduct && isCPNeverCalled) {
      getChangeProducts({
        OrderId: selectedCardData.OrderId,
        ProductIds: productInfo.productIds,
      });
    }
  }

  onResize = (e) => {
    const scrollWrapper =
      (document && document.getElementsByClassName("scrollContainer")[0]) || {};
    const firstHeadersDiv =
      (document && document.getElementsByClassName("firstHeader")[0]) || {};
    if (scrollWrapper.clientHeight < scrollWrapper.scrollHeight) {
      if (firstHeadersDiv && firstHeadersDiv.style) {
        firstHeadersDiv.style.paddingRight = getScrollbarWidth() + "px";
      }
    } else {
      if (firstHeadersDiv && firstHeadersDiv.style) {
        firstHeadersDiv.style.paddingRight = "0px";
      }
    }
  };

  onConsultationQuesScroll = (e) => {
    const headersDiv =
      document && document.getElementsByClassName("consultationTitleWrapper");
    const scrollWrapper =
      document && document.getElementsByClassName("scrollContainer")[0];
    const fixedHeadersDiv =
      document &&
      document.getElementsByClassName("consultationTitleFixWrapper");
    const parentTop =
      e.target &&
      e.target.getBoundingClientRect &&
      e.target.getBoundingClientRect().top;
    for (let i = 0; i < headersDiv.length; i++) {
      if (headersDiv[i] && headersDiv[i].getBoundingClientRect) {
        if (headersDiv[i].getBoundingClientRect().top < parentTop) {
          if (scrollWrapper.clientHeight < scrollWrapper.scrollHeight) {
            fixedHeadersDiv[i].style.paddingRight = getScrollbarWidth() + "px";
          }
          fixedHeadersDiv[i].style.display = "flex";
          headersDiv[i].style.minHeight = "0px";
          headersDiv[i].style.height = "0px";
          headersDiv[i].style.overflow = "hidden";
        } else {
          fixedHeadersDiv[i].style.display = "none";
          headersDiv[i].style.minHeight = "35px";
          headersDiv[i].style.height = "";
          headersDiv[i].style.overflow = "visible";
        }
      }
    }
  };

  pop = (url, w, h) => {
    let n = window.open(
      url,
      "_blank",
      "toolbar=0,location=0,modal=yes,alwaysRaised=yes,directories=0,status=1,menubar=0,titlebar=0,scrollbars=1,resizable=1,left=120,top=200,width=" +
        w +
        ",height=" +
        h
    );
    if (n == null) {
      return true;
    }
    return false;
  };

  CheckIfPDFExists = () => {
    const { CheckPdfExists, productInfo: { OrderId } = {} } = this.props;
    OrderId && CheckPdfExists && CheckPdfExists(OrderId);
  };

  /**
   * @todo alternateRx check should check the application settings
   * @returns {boolean}
   */
  isConfiguredAlternateRx({
    pId,
    isAlternateRx,
    skipCheckingChangeProducts,
    skipCheckingAppSettings,
  }) {
    if (isAlternateRx) {
      return true;
    }

    if (pId === ALTERNATE_RX_PRODUCT_VALUE) {
      return true;
    }

    const { productList, productInfo } = this.props;

    if (skipCheckingChangeProducts === false) {
      const { ProductItem } = productList;
      /**
       * @type {{
       *  Value: number,
       * }[]}
       */
      const changeProducts = ProductItem || [];
      /**
       * @type {boolean}
       */
      const hasAlternateRxProduct = changeProducts.some((product = {}) => {
        return product.Value === ALTERNATE_RX_PRODUCT_VALUE;
      });
      if (hasAlternateRxProduct) {
        return hasAlternateRxProduct;
      }
    }

    if (skipCheckingAppSettings === false) {
      /**
       * @type {Map<string, {
       *    key: string,
       *    value: string,
       *  }>}
       */
      const settingsCollection = new Map(productInfo?.StoreFrontData?.StorefrontApplicationSettings);
      const hasAppSetting = settingsCollection.has('AlternateRxId');
      if (hasAppSetting) {
        /**
          * @type {{
          *  key: string;
          *  value: string;
          * }}
          */
        const setting = settingsCollection.get('AlternateRxId');
        const hasAlternateRxProduct = Number(setting.value) === ALTERNATE_RX_PRODUCT_VALUE;

        if (hasAlternateRxProduct) {
          return hasAlternateRxProduct;
        }
      }
    }

    return false;
  }

  render() {
    let {
      classes,
      pdfExists,
      selectedPatientInfo: { UserId } = {},
      isHistoryView,
      productCost = {},
      productInfo = {},
      productList: { ProductItem = [] } = {},
      productListModalError,
      qtyByProduct: { QTY = "", DefaultQty } = {},
      isProductChangeModalOpen,
      consultQuestion: { ProductConsultDetails = [] } = {},
      notEditIcon,
      loading,
      changeProducts,
      addProductInfo,

      GetProductCost: getProductCost = async () => {},
      AddProduct: addProduct = async () => {},
      ResetProductCost: resetProductCost = async () => {},
      GetProductInfoV2 = async () => {},
      GetChangeProductList = async () => {}
    } = this.props;

    const tableRows = this.genrateData(productInfo);
    const testResultslink = "Click Here for Test Results";
    const Headers = [];
    const products = ProductItem || [];

    const getConsultationQuesRows = () => {
      if (ProductConsultDetails && ProductConsultDetails.length) {
        const that = this;
        return ProductConsultDetails.map((_product, productIndex) => {
          if (productIndex !== 0) {
            Headers.push(
              <div
                style={{ display: "none" }}
                className={`${classes.questionsTitleWrapper} consultationTitleFixWrapper`}
              >
                <div
                  id="consult-question-title"
                  className={classes.consultationTitle}
                >
                  Consultation Question{" "}
                  {ProductConsultDetails.length > 1
                    ? " - " + _product.ProductTitle
                    : ""}
                </div>
                <div
                  id="consult-answer-header"
                  className={classes.consultationAnswerTitle}
                >
                  Consultation Answer
                </div>
              </div>
            );
          } else {
            Headers.push(
              <div className={`${classes.questionsTitleWrapper} firstHeader`}>
                <div
                  id="consult-question-title"
                  className={classes.consultationTitle}
                >
                  Consultation Question{" "}
                  {ProductConsultDetails.length > 1
                    ? " - " + _product.ProductTitle
                    : ""}
                </div>
                <div
                  id="consult-answer-header"
                  className={classes.consultationAnswerTitle}
                >
                  Consultation Answer
                </div>
              </div>
            );
          }
          return (
            <div
              className={classes.questionsProductWrapper}
              key={productIndex + _product.ProductId}
            >
              {productIndex !== 0 ? (
                <div
                  className={`${classes.questionsTitleWrapper} consultationTitleWrapper`}
                >
                  <div
                    id="consult-question-title"
                    className={classes.consultationTitle}
                  >
                    Consultation Question{" "}
                    {ProductConsultDetails.length > 1
                      ? " - " + _product.ProductTitle
                      : ""}
                  </div>
                  <div
                    id="consult-answer-header"
                    className={classes.consultationAnswerTitle}
                  >
                    Consultation Answer
                  </div>
                </div>
              ) : null}
              {_product &&
              _product.QuestionAnswers &&
              _product.QuestionAnswers.length ? (
                _product.QuestionAnswers.map((_value, _index) => {
                  return (
                    <div
                      key={_index}
                      className={`${
                        _index % 2 !== 0
                          ? classes.questionsRowWrapper
                          : classes.questionsRowWrapperOddRow
                      }`}
                    >
                      <div
                        id="consult-question-text"
                        className={`${classes.consultationQuestionRow} ${
                          _value.Flagged ? classes.redRow : ""
                        }`}
                        dangerouslySetInnerHTML={{
                          __html: removeXSSAttacks(_value.QuestionText),
                        }}
                      ></div>
                      <div
                        id="consult-answer-text"
                        className={`${classes.consultationAnswerRow} ${
                          _value.Flagged ? classes.redRow : ""
                        }`}
                      >
                        {_value &&
                        _value.AnswerType &&
                        _value.AnswerType.toLowerCase() === "upload" ? (
                          !isHistoryView ? (
                            <a
                              id="uploaded-File-link"
                              className={classes.linkUploadedFiles}
                              target="_blank"
                              onClick={(_) =>
                                that.pop(
                                  `/viewuploads/${productInfo.OrderId}/${UserId}/${_value.QuestionId}`,
                                  1290,
                                  780
                                )
                              }
                            >
                              {_value.AnswerText}
                            </a>
                          ) : (
                            "(see most recent order)"
                          )
                        ) : (
                          _value.AnswerText
                        )}
                      </div>
                    </div>
                  );
                })
              ) : !loading ? (
                <div id="no-consult-data" className={classes.noConsultData}>
                  No consult data for this product. Please contact Maria
                  Flansbaum at 480-707-4538
                </div>
              ) : null}
            </div>
          );
        });
      } else if (!loading) {
        return (
          <div className={classes.questionsProductWrapper} key={"productIndex"}>
            <div
              className={`${classes.questionsTitleWrapper} consultationTitleWrapper`}
            >
              <div
                id="consult-question-title"
                className={classes.consultationTitle}
              >
                Consultation Question
              </div>
              <div
                id="consult-answer-header"
                className={classes.consultationAnswerTitle}
              >
                Consultation Answer
              </div>
            </div>
            <div id="no-consult-data" className={classes.noConsultData}>
              No consult data for this product. Please contact Maria Flansbaum
              at 480-707-4538
            </div>
          </div>
        );
      }
    };

    const AddProductComponent = new Map([
      ['true-true', (
        <ControlledAddProduct
          data={{
            productInfo,
            productCost,
            addProductInfo,
            changeProducts,
            version: 1,
          }}
          action={{
            getProductCost,
            addProduct,
            resetProductCost,
          }}
          GetProductInfoV2={GetProductInfoV2}
          GetChangeProductList={GetChangeProductList}
        />
      )],
      ['true-false', <></>],
      ['false-true', <></>],
      ['false-false', <></>],
    ]);

    return (
      <div
        data-app="consultTab-component-wrapper"
        className={classes.consultWrapper}
      >
        <div className={`async-or-sync-visits-screen ${classes.tableWrapper}`}>
          <div className={`${classes.orderDateStyle}`}>
            <div
              id="consult-order-date-header"
              className={`${classes.tableHeaderTitle}`}
            >
              Order Date
            </div>
            <div className={classes.tableRowWrapper}>{tableRows.OrderDate}</div>
          </div>

          <div className={`${classes.orderNumberStyle}`}>
            <div
              id="consult-order-number-header"
              className={`${classes.tableHeaderTitle}`}
            >
              Order Number
            </div>
            <div className={classes.tableRowWrapper}>{tableRows.OrderId}</div>
          </div>

          <div className={`${classes.productStyle}`}>
            <div
              id="consult-product-header"
              className={`${classes.tableHeaderTitle}`}
            >
              Product

              <div className="flex m-l-6">
                {
                  AddProductComponent.get(`${hasFeature.ADD_PRODUCT}-${changeProducts.api.data.size > 0}`)
                }
              </div>
            </div>
            <div className={classes.tableRowWrapper}>
              {tableRows.ProductTitle}
            </div>
            {
              !loading && pdfExists &&
              <div className={classes.pdfViewLinkColumn}>
                { 
                  <a
                    id="uploaded-PDF-link" 
                    className={classes.uploadedPdfLink} 
                    target="_blank" 
                    onClick={_ => this.pop(`/viewpdf/${productInfo.OrderId}`, 1290, 780)}
                  >
                    {testResultslink}
                  </a> 
                } 
              </div>
            }
          </div>

          {notEditIcon ? null : (
            <div className={`${classes.editIconWrapper}`}>
              <div
                className={`${classes.tableHeaderTitle} ${classes.iconHeader}`}
              >
                {" "}
              </div>
              <div className={classes.tableRowWrapper}>
                {tableRows.editIcon}
              </div>
            </div>
          )}

          <div className={`${classes.qty}`}>
            <div
              id="consult-qty-header"
              className={`${classes.tableHeaderTitle} ${classes.tableCenter}`}
            >
              Qty
            </div>
            <div className={classes.tableRowWrapper}>{tableRows.Qty}</div>
          </div>
          <div className={`${classes.orderType}`}>
            <div
              id="consult-order-type-header"
              className={`${classes.tableHeaderTitle} ${classes.tableCenter}`}
            >
              Order Type
            </div>
            <div className={classes.tableRowWrapper}>{tableRows.OrderType}</div>
          </div>

          <div className={`${classes.status}`}>
            <div
              id="consult-status-header"
              className={`${classes.tableHeaderTitle} ${classes.tableCenter} ${classes.statusStyle}`}
            >
              Status
            </div>
            <div
              className={`${classes.tableRowWrapper} ${classes.statusStyle}`}
            >
              {tableRows.Status}
            </div>
          </div>

          <ChangeProduct
            classes={classes}
            open={isProductChangeModalOpen}
            productItems={products}
            productListModalError={productListModalError}
            defaultQty={DefaultQty}
            quantity={QTY}
            selectedProductId={this.state.selectedProductId}
            currentProduct={this.state.currentProduct}
            orgQTYValue={this.state.orgQTYValue}
            QTYValue={this.state.QTYValue}
            reasonForChangeValue={this.state.reasonForChangeValue}
            handler={{
              onProductListChange: this.handleProductListChange,
              onQuantityChange: this.handleQuantityChange,
              onReasonForChange: this.handleReasonForChange,
              onSubmitProductChange: this.onSubmitProductChange,
              onToggleModal: this.ToggleModal
            }}
          />
        </div>
        {/* Question section  */}

        <div className={classes.questionsWrapper}>
          {Headers}
          <div
            id="consult-scroll-window"
            onScroll={this.onConsultationQuesScroll}
            className={`${classes.questionsWrapper} scrollContainer`}
          >
            {getConsultationQuesRows()}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(ConsultTabStyles)(ConsultTab);
